import { render, staticRenderFns } from "./RareGraphLegend.vue?vue&type=template&id=70a14562&scoped=true"
import script from "./RareGraphLegend.vue?vue&type=script&lang=js"
export * from "./RareGraphLegend.vue?vue&type=script&lang=js"
import style0 from "./RareGraphLegend.vue?vue&type=style&index=0&id=70a14562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a14562",
  null
  
)

export default component.exports